import { render, staticRenderFns } from "./order_pinfomy.vue?vue&type=template&id=ba5f9c82&scoped=true&"
import script from "./order_pinfomy.vue?vue&type=script&lang=js&"
export * from "./order_pinfomy.vue?vue&type=script&lang=js&"
import style0 from "./order_pinfomy.vue?vue&type=style&index=0&id=ba5f9c82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5f9c82",
  null
  
)

export default component.exports